<script setup lang="ts">
import { computed } from 'vue'
import { LOCALES, locale, setLocale, t } from '../i18n'

/** Two languages, so a toggle rather than a menu — one click, not two. */
const other = computed(() => LOCALES.find((l) => l.code !== locale.value)!)
const current = computed(() => LOCALES.find((l) => l.code === locale.value)!)
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center gap-1.5 rounded-full border border-line bg-raised px-2.5 py-1 text-[12px] font-medium text-fg-dim transition-colors hover:text-fg"
    :aria-label="`${t('app.language')} — ${other.label}`"
    @click="setLocale(other.code)"
  >
    <span class="text-[13px] leading-none" aria-hidden="true">{{ current.flag }}</span>
    <span class="font-mono uppercase">{{ current.code }}</span>
  </button>
</template>
